import React from 'react';
import moment from 'moment';
import {UpdatePropsCancelReasign} from '../../../../home/helper/request.props.js';
import {PresenterCancelReasign} from '../../../../home/presenter.js'
import RenderStatus from '../../../../utils/Render.js'
import {toast} from 'react-toastify';
import PopoverHelper from '../../../../utils/PopoverHelper';
import t from 'typy';
import { css } from 'glamor'
import Lib from 'utils/Lib';

let space = css({
  margin: '0 4px'
})

export default class AssetRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cancel_process: false
    }

    this.onChecked = this.onChecked.bind(this)

    this.cancelReasign    = this.cancelReasign.bind(this)
    this.OnCancelSuccsess = this.OnCancelSuccsess.bind(this)
    this.OnCancelFailed   = this.OnCancelFailed.bind(this)
    this.cancel           = this.cancel.bind(this)
  }

	cancelReasign(data) {
		this.requestParams = {
			Alias : data.Confirmation.Alias
		}
		PresenterCancelReasign(
			UpdatePropsCancelReasign(this, this.OnCancelSuccsess, this.OnCancelFailed)
		)
    this.setState({cancel_process: true})
  }

  OnCancelSuccsess(params, response) {
    toast.success("Success cancel reasign");
    params.self.props.self.updateRow(response.data, true);
    this.setState({cancel_process: false})
  }

  OnCancelFailed(params, response) {
    this.setState({cancel_process: false})
    try {
      Lib.responseMessage('error', response.data);
    }
    catch(error) {
      console.error(error);
    }
	}

  cancel(e) {
    e.stopPropagation()
    this.cancelReasign(this.props.RowData)
  }

  onChecked(e) {
    e.stopPropagation()
    if(e.target.id === this.props.RowData.Alias) {
      this.props.onItemsCheckChanged(e.target.checked, this.props.RowData)
    }
  }

  renderAssignInfo() {
    if(this.props.RowData.Confirmation === null) {
      return (
        <div className="small text-muted">
          <a role="button" className="apple-blue hover-apple-blue" onClick={(e)=>{e.stopPropagation(); this.props.self.toggleOpenModalReasign(this.props.RowData)}}>Re-assign</a>{' | '}
          <a role="button" className="apple-orange hover-apple-blue" onClick={(e)=>{e.stopPropagation(); this.props.self.toggleModalMoveAsset(this.props.RowData)}}>Move</a>
        </div>
      )
    } else {
      return(
        <div className="small text-muted">
          {this.state.cancel_process ?
            <a role="button"><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;</a>
            :
            <a role="button" onClick={this.cancel} title="Cancel Reassigned" className="apple-yellow">Cancel</a>
          }

          <a className="cursor-default" title="New user assigned">&nbsp;to <span>{this.props.RowData.Confirmation.ToUser}</span></a> |
          <a className="apple-yellow cursor-default" title="Status assigned">&nbsp;Waiting</a>
        </div>
      )
    }
  }

  renderCheckbox(){
    const {RowData, defaultChecked} = this.props
    if(RowData.Confirmation === null/* && RowData.NextReservation === null*/) {
      return (
        <label className="container-checkbox" onClick={this.onChecked}>
          <input type="checkbox" checked={defaultChecked} id={RowData.Alias}/>
          <span className="checkmark"></span>
        </label>
      )
    } else {
      return(
        <PopoverHelper
          id={"id"+RowData.Alias}
          placement="right"
          mLeft="0"
          content="Sorry this asset is not available, waiting confirmation from previous re-assignment"
        />
      )
    }
  }

  render() {
    let {RowData} = this.props;
    let {UserReducer} = this.props.self.props;;

    let nextReservation = () => {
      if(RowData.NextReservation !== null){
        return (
          <span>{RowData.NextReservation.User.FirstName + ' ' + RowData.NextReservation.User.LastName} needs it on {moment(RowData.NextReservation.StartDate).format('ll')}</span>
        )
      }else{
        return(
          <span>No Next Reservation</span>
        )
      }
    }

    let dueDate = () => {
      if(t(RowData, 'Tracking.DueDate').safeObject === null) {
        return (<span className="box-item-center"><span>-</span></span>);
      } else {
        if(moment(t(RowData, 'Tracking.DueDate').safeObject) < moment()) {
          return (
            <span className="box-item-center">
              <span className="apple-red">{moment(t(RowData, 'Tracking.DueDate').safeObject).format('ll')}</span>
              <a role="button" onClick={(e)=>{e.stopPropagation(); this.props.self.openModalExtend(RowData)}} className="apple-blue hover-apple-blue extend-button">extend</a>
              <span className="pulse"></span>
            </span>
            )
        } else {
          return (
            <span className="box-item-center block">
              <span>{moment(t(RowData, 'Tracking.DueDate').safeObject).format('ll')}</span>
              <a role="button" onClick={(e)=>{e.stopPropagation(); this.props.self.openModalExtend(RowData)}} className="apple-blue hover-apple-blue extend-button">extend</a>
            </span>
          )
        }
      }
    }

    return (
      <tr onClick={(e)=>this.props.self.toggleModalDetail(e, RowData)}>
        <td>
          {this.renderCheckbox()}
        </td>
        <td>
          <div >
            <strong role="button" className="spaceR">{RowData.Name}</strong>(<span>{RowData.Description}</span>)
          </div>
          <div className="small text-muted">
            <span {...space}>Created: {moment(t(RowData, 'Tracking.ChekinTime').safeObject).format('ll')}</span>
            &middot;
            <span {...space}>From Now: {moment(t(RowData, 'Tracking.ChekinTime').safeObject).fromNow()}</span>
          </div>
        </td>
        <td>
          <div>
            {dueDate()}
          </div>
          <div className="small text-muted">
            {nextReservation()}
          </div>
        </td>
        <td>
          <span>{t(RowData, 'SerialNumber').safeObject === null ? '-' : t(RowData, 'SerialNumber').safeObject}</span>
        </td>
        <td>
          <span>{t(RowData, 'Site.Name').safeObject === null ? '-' : t(RowData, 'Site.Name').safeObject}</span>
        </td>
        <td>
          <span>{t(RowData, 'Location.Name').safeObject === null ? '-' : t(RowData, 'Location.Name').safeObject}</span>
        </td>
        <td>
          <span>{t(RowData, 'Type.Name').safeObject === null ? '-' : t(RowData, 'Type.Name').safeObject}</span>
        </td>
        <td>
          <span>{t(RowData, 'Status.Name').safeObject === null ? '-' : t(RowData, 'Status.Name').safeObject}</span>
        </td>
        <td>
          <div>
            <div><span>{UserReducer.props.first_name}</span>&nbsp;<span>{UserReducer.props.last_name}</span></div>
            {this.renderAssignInfo()}
          </div>
        </td>
        <td className="text-center">
          {RenderStatus.MaintenaceStatus(RowData, this.props)}
        </td>
      </tr>
    );
  }

}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/MyAsset/AssetRow.js